import {
  BedDoubleIcon,
  Building2Icon,
  CastleIcon,
  HouseIcon,
  type LucideIcon,
  TentIcon,
  TreePineIcon,
  WarehouseIcon,
} from 'lucide-react'

/**
 * Location categories ("Typ ubytování") come from /enum in admin order; only
 * the icon is ours, keyed by the category slug. A category added in admin
 * without an entry here falls back to the generic house.
 */
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  glamping: TentIcon,
  chata: HouseIcon,
  chalupa: HouseIcon,
  roubenka: WarehouseIcon,
  srub: TreePineIcon,
  penzion: BedDoubleIcon,
  apartman: Building2Icon,
  vila: CastleIcon,
}

export function categoryIcon(slug: string | undefined): LucideIcon {
  return (slug && CATEGORY_ICONS[slug]) || HouseIcon
}

/** Parses the comma-separated URL param (`chata,glamping`) into slugs. */
export function parseCategorySlugs(category: string | undefined): string[] {
  if (!category) {
    return []
  }
  return category
    .split(',')
    .map((slug) => slug.trim())
    .filter((slug) => /^[a-z0-9-]+$/.test(slug))
}

export function serializeCategorySlugs(slugs: string[]): string | undefined {
  return slugs.length > 0 ? slugs.join(',') : undefined
}
